"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeReports = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const redux_observable_1 = require("redux-observable");
const Actions = require("../../actions/reports/removal");
const ActionTypes = require("../../actionTypes/reports/removal");
const ListActions = require("../../actions/reports/list");
const ErrorHandling = require("../../utils/errorHandling");
const removeReports = (action$, _store, { ajax, getToken, baseUrl }) => {
    const ajaxOptions = (payload) => {
        const { type } = payload, body = __rest(payload, ["type"]);
        const url = type === 'TEMPLATE'
            ? `${baseUrl}api/reports/templates`
            : `${baseUrl}api/reports`;
        return {
            method: 'DELETE',
            url,
            body: JSON.stringify(body),
            headers: {
                Authorization: getToken(),
                'Content-Type': 'application/json'
            }
        };
    };
    const ajaxCall = (payload) => ajax(ajaxOptions(payload)).pipe((0, operators_1.mergeMap)((response) => (0, rxjs_1.of)(Actions.removeReportsSuccess(response.response), ListActions.fetchReportListRequest(payload.customerId, payload.type))), (0, operators_1.catchError)((error) => {
        const responseError = ErrorHandling.parseAjaxErrorResponse(error);
        return (0, rxjs_1.of)(Actions.removeReportsFailure(responseError));
    }));
    return action$.pipe((0, redux_observable_1.ofType)(ActionTypes.REMOVE_REPORTS_REQUEST), (0, operators_1.map)((action) => action), (0, operators_1.switchMap)(({ payload }) => ajaxCall(payload)));
};
exports.removeReports = removeReports;
//# sourceMappingURL=removal.js.map